<h1 mat-dialog-title i18n="Client Time Shift|Client time is different title@@client-time-shift-time-different-title">
  Local Time Shift</h1>
<div mat-dialog-content #dialogContent>
  <p i18n="Client Time Shift|Client time shift description@@client-time-shift-time-different-description">
    Client time on this device is significantly different from server time. Contest duration is tied to a period after
    you start the test. Shifted local time can cause issues with the contest countdown timer. As a result, the timer
    might not be accurate, and you cannot rely on it.
  </p>
  <p i18n="Client Time Shift|Server time title@@client-time-shift-server-time-title">Server time:</p>
  <p class="color-green">{{serverTime | date:'medium'}}</p>
  <p i18n="Client Time Shift|Client time title@@client-time-shift-client-time-title">Client time:</p>
  <p class="color-orange">{{clientTime | date:'medium'}}</p>
  <p i18n="Client Time Shift|Client time shift action@@client-time-shift-time-different-action"
     class="color-warn center-align mat-h2">Fix time settings on your device before proceeding with a contest to avoid
    issues.</p>
</div>
<div mat-dialog-actions>
  <app-button label="Close"
              i18n-label="General|Close action label@@general-close-action-label"
              [disabled]="inProgress"
              (clicked)="closeModal()"
              [secondary]="true"></app-button>
</div>
